
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5THiV"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("kDLVk"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("eIzhc"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("jxVKW"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("3KzPf"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("31xgG"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("2ONyh"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("cXI0Q"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("1Jm7t"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fckJD"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("aNmI5"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("cnRNp"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("5THiV", function(module, exports) {

let $44b3ae20c24799b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $44b3ae20c24799b6$var$load("2YffH"),
    $44b3ae20c24799b6$var$load("1o23t"),
    $44b3ae20c24799b6$var$load("b7OPx"),
    $44b3ae20c24799b6$var$load("lqFMg"),
    $44b3ae20c24799b6$var$load("gELW6"),
    $44b3ae20c24799b6$var$load("4hDGB"),
    $44b3ae20c24799b6$var$load("7o5Pu"),
    $44b3ae20c24799b6$var$load("1H5IN"),
    $44b3ae20c24799b6$var$load("eBRUf"),
    $44b3ae20c24799b6$var$load("h4Nf7"),
    $44b3ae20c24799b6$var$load("7f9Fz"),
    $44b3ae20c24799b6$var$load("8YSo7"),
    $44b3ae20c24799b6$var$load("hwT9D"),
    $44b3ae20c24799b6$var$load("j4Bpe"),
    $44b3ae20c24799b6$var$load("7do1E"),
    $44b3ae20c24799b6$var$load("77dkW"),
    $44b3ae20c24799b6$var$load("g9CVe"),
    $44b3ae20c24799b6$var$load("9hYRW"),
    $44b3ae20c24799b6$var$load("kpm7S"),
    $44b3ae20c24799b6$var$load("6wr18"),
    $44b3ae20c24799b6$var$load("kjZZD"),
    $44b3ae20c24799b6$var$load("fkb26"),
    $44b3ae20c24799b6$var$load("9AXkC"),
    $44b3ae20c24799b6$var$load("ffEVr"),
    $44b3ae20c24799b6$var$load("28arV"),
    $44b3ae20c24799b6$var$load("lkwGP"),
    $44b3ae20c24799b6$var$load("fGPXi"),
    $44b3ae20c24799b6$var$load("2vAWg"),
    $44b3ae20c24799b6$var$load("7cABH"),
    $44b3ae20c24799b6$var$load("31vk5"),
    $44b3ae20c24799b6$var$load("dkgtP"),
    $44b3ae20c24799b6$var$load("g43Ev"),
    $44b3ae20c24799b6$var$load("2uVTT"),
    $44b3ae20c24799b6$var$load("hhss7"),
    $44b3ae20c24799b6$var$load("Wowvf"),
    $44b3ae20c24799b6$var$load("5RR9C"),
    $44b3ae20c24799b6$var$load("2PePB"),
    $44b3ae20c24799b6$var$load("bIPPg"),
    $44b3ae20c24799b6$var$load("lnKog"),
    $44b3ae20c24799b6$var$load("h3ABO"),
    $44b3ae20c24799b6$var$load("kC80R"),
    $44b3ae20c24799b6$var$load("7EorR"),
    $44b3ae20c24799b6$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("kDLVk", function(module, exports) {

let $f06c9fce84d45ab2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f06c9fce84d45ab2$var$load("2YffH"),
    $f06c9fce84d45ab2$var$load("1o23t"),
    $f06c9fce84d45ab2$var$load("b7OPx"),
    $f06c9fce84d45ab2$var$load("lqFMg"),
    $f06c9fce84d45ab2$var$load("gELW6"),
    $f06c9fce84d45ab2$var$load("4hDGB"),
    $f06c9fce84d45ab2$var$load("7o5Pu"),
    $f06c9fce84d45ab2$var$load("1H5IN"),
    $f06c9fce84d45ab2$var$load("eBRUf"),
    $f06c9fce84d45ab2$var$load("h4Nf7"),
    $f06c9fce84d45ab2$var$load("7f9Fz"),
    $f06c9fce84d45ab2$var$load("8YSo7"),
    $f06c9fce84d45ab2$var$load("hwT9D"),
    $f06c9fce84d45ab2$var$load("j4Bpe"),
    $f06c9fce84d45ab2$var$load("7do1E"),
    $f06c9fce84d45ab2$var$load("77dkW"),
    $f06c9fce84d45ab2$var$load("g9CVe"),
    $f06c9fce84d45ab2$var$load("9hYRW"),
    $f06c9fce84d45ab2$var$load("kpm7S"),
    $f06c9fce84d45ab2$var$load("6wr18"),
    $f06c9fce84d45ab2$var$load("kjZZD"),
    $f06c9fce84d45ab2$var$load("fkb26"),
    $f06c9fce84d45ab2$var$load("9AXkC"),
    $f06c9fce84d45ab2$var$load("ffEVr"),
    $f06c9fce84d45ab2$var$load("28arV"),
    $f06c9fce84d45ab2$var$load("lkwGP"),
    $f06c9fce84d45ab2$var$load("fGPXi"),
    $f06c9fce84d45ab2$var$load("2vAWg"),
    $f06c9fce84d45ab2$var$load("7cABH"),
    $f06c9fce84d45ab2$var$load("31vk5"),
    $f06c9fce84d45ab2$var$load("dkgtP"),
    $f06c9fce84d45ab2$var$load("g43Ev"),
    $f06c9fce84d45ab2$var$load("2uVTT"),
    $f06c9fce84d45ab2$var$load("hhss7"),
    $f06c9fce84d45ab2$var$load("Wowvf"),
    $f06c9fce84d45ab2$var$load("5RR9C"),
    $f06c9fce84d45ab2$var$load("2PePB"),
    $f06c9fce84d45ab2$var$load("bIPPg"),
    $f06c9fce84d45ab2$var$load("lnKog"),
    $f06c9fce84d45ab2$var$load("h3ABO"),
    $f06c9fce84d45ab2$var$load("kC80R"),
    $f06c9fce84d45ab2$var$load("7EorR"),
    $f06c9fce84d45ab2$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("eIzhc", function(module, exports) {

let $ab7089ee9c3a5861$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab7089ee9c3a5861$var$load("2YffH"),
    $ab7089ee9c3a5861$var$load("1o23t"),
    $ab7089ee9c3a5861$var$load("b7OPx"),
    $ab7089ee9c3a5861$var$load("lqFMg"),
    $ab7089ee9c3a5861$var$load("gELW6"),
    $ab7089ee9c3a5861$var$load("4hDGB"),
    $ab7089ee9c3a5861$var$load("7o5Pu"),
    $ab7089ee9c3a5861$var$load("1H5IN"),
    $ab7089ee9c3a5861$var$load("eBRUf"),
    $ab7089ee9c3a5861$var$load("h4Nf7"),
    $ab7089ee9c3a5861$var$load("7f9Fz"),
    $ab7089ee9c3a5861$var$load("8YSo7"),
    $ab7089ee9c3a5861$var$load("hwT9D"),
    $ab7089ee9c3a5861$var$load("j4Bpe"),
    $ab7089ee9c3a5861$var$load("7do1E"),
    $ab7089ee9c3a5861$var$load("77dkW"),
    $ab7089ee9c3a5861$var$load("g9CVe"),
    $ab7089ee9c3a5861$var$load("9hYRW"),
    $ab7089ee9c3a5861$var$load("kpm7S"),
    $ab7089ee9c3a5861$var$load("6wr18"),
    $ab7089ee9c3a5861$var$load("kjZZD"),
    $ab7089ee9c3a5861$var$load("fkb26"),
    $ab7089ee9c3a5861$var$load("9AXkC"),
    $ab7089ee9c3a5861$var$load("ffEVr"),
    $ab7089ee9c3a5861$var$load("28arV"),
    $ab7089ee9c3a5861$var$load("lkwGP"),
    $ab7089ee9c3a5861$var$load("fGPXi"),
    $ab7089ee9c3a5861$var$load("2vAWg"),
    $ab7089ee9c3a5861$var$load("7cABH"),
    $ab7089ee9c3a5861$var$load("31vk5"),
    $ab7089ee9c3a5861$var$load("dkgtP"),
    $ab7089ee9c3a5861$var$load("g43Ev"),
    $ab7089ee9c3a5861$var$load("2uVTT"),
    $ab7089ee9c3a5861$var$load("hhss7"),
    $ab7089ee9c3a5861$var$load("Wowvf"),
    $ab7089ee9c3a5861$var$load("5RR9C"),
    $ab7089ee9c3a5861$var$load("2PePB"),
    $ab7089ee9c3a5861$var$load("bIPPg"),
    $ab7089ee9c3a5861$var$load("lnKog"),
    $ab7089ee9c3a5861$var$load("h3ABO"),
    $ab7089ee9c3a5861$var$load("kC80R"),
    $ab7089ee9c3a5861$var$load("7EorR"),
    $ab7089ee9c3a5861$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("jxVKW", function(module, exports) {

let $e3ade688944df46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3ade688944df46b$var$load("7do1E"),
    $e3ade688944df46b$var$load("77dkW"),
    $e3ade688944df46b$var$load("2YffH"),
    $e3ade688944df46b$var$load("b7OPx"),
    $e3ade688944df46b$var$load("lqFMg"),
    $e3ade688944df46b$var$load("gELW6"),
    $e3ade688944df46b$var$load("4hDGB"),
    $e3ade688944df46b$var$load("2PePB"),
    $e3ade688944df46b$var$load("eBRUf"),
    $e3ade688944df46b$var$load("h4Nf7"),
    $e3ade688944df46b$var$load("7f9Fz"),
    $e3ade688944df46b$var$load("8YSo7"),
    $e3ade688944df46b$var$load("hwT9D"),
    $e3ade688944df46b$var$load("j4Bpe"),
    $e3ade688944df46b$var$load("g9CVe"),
    $e3ade688944df46b$var$load("9hYRW"),
    $e3ade688944df46b$var$load("kpm7S"),
    $e3ade688944df46b$var$load("6wr18"),
    $e3ade688944df46b$var$load("kjZZD"),
    $e3ade688944df46b$var$load("fkb26"),
    $e3ade688944df46b$var$load("9AXkC"),
    $e3ade688944df46b$var$load("ffEVr"),
    $e3ade688944df46b$var$load("28arV"),
    $e3ade688944df46b$var$load("lkwGP"),
    $e3ade688944df46b$var$load("fGPXi"),
    $e3ade688944df46b$var$load("2vAWg"),
    $e3ade688944df46b$var$load("7cABH"),
    $e3ade688944df46b$var$load("31vk5"),
    $e3ade688944df46b$var$load("dkgtP"),
    $e3ade688944df46b$var$load("g43Ev"),
    $e3ade688944df46b$var$load("bIPPg"),
    $e3ade688944df46b$var$load("2uVTT"),
    $e3ade688944df46b$var$load("hhss7"),
    $e3ade688944df46b$var$load("Wowvf"),
    $e3ade688944df46b$var$load("5RR9C"),
    $e3ade688944df46b$var$load("h3ABO"),
    $e3ade688944df46b$var$load("kC80R"),
    $e3ade688944df46b$var$load("7EorR"),
    $e3ade688944df46b$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("3KzPf", function(module, exports) {

let $2bb1753453da6728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2bb1753453da6728$var$load("7do1E"),
    $2bb1753453da6728$var$load("77dkW"),
    $2bb1753453da6728$var$load("2YffH"),
    $2bb1753453da6728$var$load("b7OPx"),
    $2bb1753453da6728$var$load("lqFMg"),
    $2bb1753453da6728$var$load("gELW6"),
    $2bb1753453da6728$var$load("4hDGB"),
    $2bb1753453da6728$var$load("2PePB"),
    $2bb1753453da6728$var$load("eBRUf"),
    $2bb1753453da6728$var$load("h4Nf7"),
    $2bb1753453da6728$var$load("7f9Fz"),
    $2bb1753453da6728$var$load("8YSo7"),
    $2bb1753453da6728$var$load("hwT9D"),
    $2bb1753453da6728$var$load("j4Bpe"),
    $2bb1753453da6728$var$load("g9CVe"),
    $2bb1753453da6728$var$load("9hYRW"),
    $2bb1753453da6728$var$load("kpm7S"),
    $2bb1753453da6728$var$load("6wr18"),
    $2bb1753453da6728$var$load("kjZZD"),
    $2bb1753453da6728$var$load("fkb26"),
    $2bb1753453da6728$var$load("9AXkC"),
    $2bb1753453da6728$var$load("ffEVr"),
    $2bb1753453da6728$var$load("28arV"),
    $2bb1753453da6728$var$load("lkwGP"),
    $2bb1753453da6728$var$load("fGPXi"),
    $2bb1753453da6728$var$load("2vAWg"),
    $2bb1753453da6728$var$load("7cABH"),
    $2bb1753453da6728$var$load("31vk5"),
    $2bb1753453da6728$var$load("dkgtP"),
    $2bb1753453da6728$var$load("g43Ev"),
    $2bb1753453da6728$var$load("bIPPg"),
    $2bb1753453da6728$var$load("2uVTT"),
    $2bb1753453da6728$var$load("hhss7"),
    $2bb1753453da6728$var$load("Wowvf"),
    $2bb1753453da6728$var$load("5RR9C"),
    $2bb1753453da6728$var$load("h3ABO"),
    $2bb1753453da6728$var$load("kC80R"),
    $2bb1753453da6728$var$load("7EorR"),
    $2bb1753453da6728$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("31xgG", function(module, exports) {

let $233b4577150f1719$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $233b4577150f1719$var$load("7do1E"),
    $233b4577150f1719$var$load("77dkW"),
    $233b4577150f1719$var$load("2YffH"),
    $233b4577150f1719$var$load("b7OPx"),
    $233b4577150f1719$var$load("lqFMg"),
    $233b4577150f1719$var$load("gELW6"),
    $233b4577150f1719$var$load("4hDGB"),
    $233b4577150f1719$var$load("2PePB"),
    $233b4577150f1719$var$load("eBRUf"),
    $233b4577150f1719$var$load("h4Nf7"),
    $233b4577150f1719$var$load("7f9Fz"),
    $233b4577150f1719$var$load("8YSo7"),
    $233b4577150f1719$var$load("hwT9D"),
    $233b4577150f1719$var$load("j4Bpe"),
    $233b4577150f1719$var$load("g9CVe"),
    $233b4577150f1719$var$load("9hYRW"),
    $233b4577150f1719$var$load("kpm7S"),
    $233b4577150f1719$var$load("6wr18"),
    $233b4577150f1719$var$load("kjZZD"),
    $233b4577150f1719$var$load("fkb26"),
    $233b4577150f1719$var$load("9AXkC"),
    $233b4577150f1719$var$load("ffEVr"),
    $233b4577150f1719$var$load("28arV"),
    $233b4577150f1719$var$load("lkwGP"),
    $233b4577150f1719$var$load("fGPXi"),
    $233b4577150f1719$var$load("2vAWg"),
    $233b4577150f1719$var$load("7cABH"),
    $233b4577150f1719$var$load("31vk5"),
    $233b4577150f1719$var$load("dkgtP"),
    $233b4577150f1719$var$load("g43Ev"),
    $233b4577150f1719$var$load("bIPPg"),
    $233b4577150f1719$var$load("2uVTT"),
    $233b4577150f1719$var$load("hhss7"),
    $233b4577150f1719$var$load("Wowvf"),
    $233b4577150f1719$var$load("5RR9C"),
    $233b4577150f1719$var$load("h3ABO"),
    $233b4577150f1719$var$load("kC80R"),
    $233b4577150f1719$var$load("7EorR"),
    $233b4577150f1719$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("2ONyh", function(module, exports) {

let $20d6b04535c5db76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20d6b04535c5db76$var$load("7do1E"),
    $20d6b04535c5db76$var$load("77dkW"),
    $20d6b04535c5db76$var$load("2YffH"),
    $20d6b04535c5db76$var$load("b7OPx"),
    $20d6b04535c5db76$var$load("lqFMg"),
    $20d6b04535c5db76$var$load("gELW6"),
    $20d6b04535c5db76$var$load("4hDGB"),
    $20d6b04535c5db76$var$load("eBRUf"),
    $20d6b04535c5db76$var$load("h4Nf7"),
    $20d6b04535c5db76$var$load("7f9Fz"),
    $20d6b04535c5db76$var$load("8YSo7"),
    $20d6b04535c5db76$var$load("hwT9D"),
    $20d6b04535c5db76$var$load("j4Bpe"),
    $20d6b04535c5db76$var$load("g9CVe"),
    $20d6b04535c5db76$var$load("9hYRW"),
    $20d6b04535c5db76$var$load("kpm7S"),
    $20d6b04535c5db76$var$load("6wr18"),
    $20d6b04535c5db76$var$load("kjZZD"),
    $20d6b04535c5db76$var$load("fkb26"),
    $20d6b04535c5db76$var$load("9AXkC"),
    $20d6b04535c5db76$var$load("ffEVr"),
    $20d6b04535c5db76$var$load("28arV"),
    $20d6b04535c5db76$var$load("lkwGP"),
    $20d6b04535c5db76$var$load("fGPXi"),
    $20d6b04535c5db76$var$load("2vAWg"),
    $20d6b04535c5db76$var$load("7cABH"),
    $20d6b04535c5db76$var$load("31vk5"),
    $20d6b04535c5db76$var$load("dkgtP"),
    $20d6b04535c5db76$var$load("g43Ev"),
    $20d6b04535c5db76$var$load("2uVTT"),
    $20d6b04535c5db76$var$load("hhss7"),
    $20d6b04535c5db76$var$load("Wowvf"),
    $20d6b04535c5db76$var$load("5RR9C"),
    $20d6b04535c5db76$var$load("2PePB"),
    $20d6b04535c5db76$var$load("bIPPg"),
    $20d6b04535c5db76$var$load("lnKog"),
    $20d6b04535c5db76$var$load("h3ABO"),
    $20d6b04535c5db76$var$load("kC80R"),
    $20d6b04535c5db76$var$load("7EorR"),
    $20d6b04535c5db76$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("cXI0Q", function(module, exports) {

let $96fd22b1998ad71c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $96fd22b1998ad71c$var$load("2YffH"),
    $96fd22b1998ad71c$var$load("b7OPx"),
    $96fd22b1998ad71c$var$load("lqFMg"),
    $96fd22b1998ad71c$var$load("gELW6"),
    $96fd22b1998ad71c$var$load("4hDGB"),
    $96fd22b1998ad71c$var$load("1H5IN"),
    $96fd22b1998ad71c$var$load("eBRUf"),
    $96fd22b1998ad71c$var$load("h4Nf7"),
    $96fd22b1998ad71c$var$load("7f9Fz"),
    $96fd22b1998ad71c$var$load("8YSo7"),
    $96fd22b1998ad71c$var$load("hwT9D"),
    $96fd22b1998ad71c$var$load("j4Bpe"),
    $96fd22b1998ad71c$var$load("7do1E"),
    $96fd22b1998ad71c$var$load("77dkW"),
    $96fd22b1998ad71c$var$load("g9CVe"),
    $96fd22b1998ad71c$var$load("9hYRW"),
    $96fd22b1998ad71c$var$load("kpm7S"),
    $96fd22b1998ad71c$var$load("6wr18"),
    $96fd22b1998ad71c$var$load("kjZZD"),
    $96fd22b1998ad71c$var$load("fkb26"),
    $96fd22b1998ad71c$var$load("9AXkC"),
    $96fd22b1998ad71c$var$load("ffEVr"),
    $96fd22b1998ad71c$var$load("28arV"),
    $96fd22b1998ad71c$var$load("lkwGP"),
    $96fd22b1998ad71c$var$load("fGPXi"),
    $96fd22b1998ad71c$var$load("2vAWg"),
    $96fd22b1998ad71c$var$load("7cABH"),
    $96fd22b1998ad71c$var$load("31vk5"),
    $96fd22b1998ad71c$var$load("dkgtP"),
    $96fd22b1998ad71c$var$load("g43Ev"),
    $96fd22b1998ad71c$var$load("2uVTT"),
    $96fd22b1998ad71c$var$load("hhss7"),
    $96fd22b1998ad71c$var$load("Wowvf"),
    $96fd22b1998ad71c$var$load("5RR9C"),
    $96fd22b1998ad71c$var$load("2PePB"),
    $96fd22b1998ad71c$var$load("bIPPg"),
    $96fd22b1998ad71c$var$load("lnKog"),
    $96fd22b1998ad71c$var$load("h3ABO"),
    $96fd22b1998ad71c$var$load("kC80R"),
    $96fd22b1998ad71c$var$load("7EorR"),
    $96fd22b1998ad71c$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("1Jm7t", function(module, exports) {

let $142b26e66ff43a4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $142b26e66ff43a4b$var$load("2YffH"),
    $142b26e66ff43a4b$var$load("b7OPx"),
    $142b26e66ff43a4b$var$load("lqFMg"),
    $142b26e66ff43a4b$var$load("gELW6"),
    $142b26e66ff43a4b$var$load("4hDGB"),
    $142b26e66ff43a4b$var$load("1H5IN"),
    $142b26e66ff43a4b$var$load("eBRUf"),
    $142b26e66ff43a4b$var$load("h4Nf7"),
    $142b26e66ff43a4b$var$load("7f9Fz"),
    $142b26e66ff43a4b$var$load("8YSo7"),
    $142b26e66ff43a4b$var$load("hwT9D"),
    $142b26e66ff43a4b$var$load("j4Bpe"),
    $142b26e66ff43a4b$var$load("7do1E"),
    $142b26e66ff43a4b$var$load("77dkW"),
    $142b26e66ff43a4b$var$load("g9CVe"),
    $142b26e66ff43a4b$var$load("9hYRW"),
    $142b26e66ff43a4b$var$load("kpm7S"),
    $142b26e66ff43a4b$var$load("6wr18"),
    $142b26e66ff43a4b$var$load("kjZZD"),
    $142b26e66ff43a4b$var$load("fkb26"),
    $142b26e66ff43a4b$var$load("9AXkC"),
    $142b26e66ff43a4b$var$load("ffEVr"),
    $142b26e66ff43a4b$var$load("28arV"),
    $142b26e66ff43a4b$var$load("lkwGP"),
    $142b26e66ff43a4b$var$load("fGPXi"),
    $142b26e66ff43a4b$var$load("2vAWg"),
    $142b26e66ff43a4b$var$load("7cABH"),
    $142b26e66ff43a4b$var$load("31vk5"),
    $142b26e66ff43a4b$var$load("dkgtP"),
    $142b26e66ff43a4b$var$load("g43Ev"),
    $142b26e66ff43a4b$var$load("2uVTT"),
    $142b26e66ff43a4b$var$load("hhss7"),
    $142b26e66ff43a4b$var$load("Wowvf"),
    $142b26e66ff43a4b$var$load("5RR9C"),
    $142b26e66ff43a4b$var$load("2PePB"),
    $142b26e66ff43a4b$var$load("bIPPg"),
    $142b26e66ff43a4b$var$load("lnKog"),
    $142b26e66ff43a4b$var$load("h3ABO"),
    $142b26e66ff43a4b$var$load("kC80R"),
    $142b26e66ff43a4b$var$load("7EorR"),
    $142b26e66ff43a4b$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fckJD", function(module, exports) {

let $b1080f8eaf8be894$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1080f8eaf8be894$var$load("7do1E"),
    $b1080f8eaf8be894$var$load("77dkW"),
    $b1080f8eaf8be894$var$load("2YffH"),
    $b1080f8eaf8be894$var$load("b7OPx"),
    $b1080f8eaf8be894$var$load("lqFMg"),
    $b1080f8eaf8be894$var$load("gELW6"),
    $b1080f8eaf8be894$var$load("4hDGB"),
    $b1080f8eaf8be894$var$load("2PePB"),
    $b1080f8eaf8be894$var$load("eBRUf"),
    $b1080f8eaf8be894$var$load("h4Nf7"),
    $b1080f8eaf8be894$var$load("7f9Fz"),
    $b1080f8eaf8be894$var$load("8YSo7"),
    $b1080f8eaf8be894$var$load("hwT9D"),
    $b1080f8eaf8be894$var$load("j4Bpe"),
    $b1080f8eaf8be894$var$load("g9CVe"),
    $b1080f8eaf8be894$var$load("9hYRW"),
    $b1080f8eaf8be894$var$load("kpm7S"),
    $b1080f8eaf8be894$var$load("6wr18"),
    $b1080f8eaf8be894$var$load("kjZZD"),
    $b1080f8eaf8be894$var$load("fkb26"),
    $b1080f8eaf8be894$var$load("9AXkC"),
    $b1080f8eaf8be894$var$load("ffEVr"),
    $b1080f8eaf8be894$var$load("28arV"),
    $b1080f8eaf8be894$var$load("lkwGP"),
    $b1080f8eaf8be894$var$load("fGPXi"),
    $b1080f8eaf8be894$var$load("2vAWg"),
    $b1080f8eaf8be894$var$load("7cABH"),
    $b1080f8eaf8be894$var$load("31vk5"),
    $b1080f8eaf8be894$var$load("dkgtP"),
    $b1080f8eaf8be894$var$load("g43Ev"),
    $b1080f8eaf8be894$var$load("bIPPg"),
    $b1080f8eaf8be894$var$load("2uVTT"),
    $b1080f8eaf8be894$var$load("hhss7"),
    $b1080f8eaf8be894$var$load("Wowvf"),
    $b1080f8eaf8be894$var$load("5RR9C"),
    $b1080f8eaf8be894$var$load("h3ABO"),
    $b1080f8eaf8be894$var$load("kC80R"),
    $b1080f8eaf8be894$var$load("7EorR"),
    $b1080f8eaf8be894$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("aNmI5", function(module, exports) {

let $7dc018ba9e28828d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7dc018ba9e28828d$var$load("7do1E"),
    $7dc018ba9e28828d$var$load("77dkW"),
    $7dc018ba9e28828d$var$load("2YffH"),
    $7dc018ba9e28828d$var$load("b7OPx"),
    $7dc018ba9e28828d$var$load("lqFMg"),
    $7dc018ba9e28828d$var$load("gELW6"),
    $7dc018ba9e28828d$var$load("4hDGB"),
    $7dc018ba9e28828d$var$load("eBRUf"),
    $7dc018ba9e28828d$var$load("h4Nf7"),
    $7dc018ba9e28828d$var$load("7f9Fz"),
    $7dc018ba9e28828d$var$load("8YSo7"),
    $7dc018ba9e28828d$var$load("hwT9D"),
    $7dc018ba9e28828d$var$load("j4Bpe"),
    $7dc018ba9e28828d$var$load("g9CVe"),
    $7dc018ba9e28828d$var$load("9hYRW"),
    $7dc018ba9e28828d$var$load("kpm7S"),
    $7dc018ba9e28828d$var$load("6wr18"),
    $7dc018ba9e28828d$var$load("kjZZD"),
    $7dc018ba9e28828d$var$load("fkb26"),
    $7dc018ba9e28828d$var$load("9AXkC"),
    $7dc018ba9e28828d$var$load("ffEVr"),
    $7dc018ba9e28828d$var$load("28arV"),
    $7dc018ba9e28828d$var$load("lkwGP"),
    $7dc018ba9e28828d$var$load("fGPXi"),
    $7dc018ba9e28828d$var$load("2vAWg"),
    $7dc018ba9e28828d$var$load("7cABH"),
    $7dc018ba9e28828d$var$load("31vk5"),
    $7dc018ba9e28828d$var$load("dkgtP"),
    $7dc018ba9e28828d$var$load("g43Ev"),
    $7dc018ba9e28828d$var$load("2uVTT"),
    $7dc018ba9e28828d$var$load("hhss7"),
    $7dc018ba9e28828d$var$load("Wowvf"),
    $7dc018ba9e28828d$var$load("5RR9C"),
    $7dc018ba9e28828d$var$load("2PePB"),
    $7dc018ba9e28828d$var$load("bIPPg"),
    $7dc018ba9e28828d$var$load("lnKog"),
    $7dc018ba9e28828d$var$load("h3ABO"),
    $7dc018ba9e28828d$var$load("kC80R"),
    $7dc018ba9e28828d$var$load("7EorR"),
    $7dc018ba9e28828d$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("cnRNp", function(module, exports) {

let $90415cbe0ed3e0a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90415cbe0ed3e0a0$var$load("7do1E"),
    $90415cbe0ed3e0a0$var$load("77dkW"),
    $90415cbe0ed3e0a0$var$load("2YffH"),
    $90415cbe0ed3e0a0$var$load("b7OPx"),
    $90415cbe0ed3e0a0$var$load("lqFMg"),
    $90415cbe0ed3e0a0$var$load("gELW6"),
    $90415cbe0ed3e0a0$var$load("4hDGB"),
    $90415cbe0ed3e0a0$var$load("eBRUf"),
    $90415cbe0ed3e0a0$var$load("h4Nf7"),
    $90415cbe0ed3e0a0$var$load("7f9Fz"),
    $90415cbe0ed3e0a0$var$load("8YSo7"),
    $90415cbe0ed3e0a0$var$load("hwT9D"),
    $90415cbe0ed3e0a0$var$load("j4Bpe"),
    $90415cbe0ed3e0a0$var$load("g9CVe"),
    $90415cbe0ed3e0a0$var$load("9hYRW"),
    $90415cbe0ed3e0a0$var$load("kpm7S"),
    $90415cbe0ed3e0a0$var$load("6wr18"),
    $90415cbe0ed3e0a0$var$load("kjZZD"),
    $90415cbe0ed3e0a0$var$load("fkb26"),
    $90415cbe0ed3e0a0$var$load("9AXkC"),
    $90415cbe0ed3e0a0$var$load("ffEVr"),
    $90415cbe0ed3e0a0$var$load("28arV"),
    $90415cbe0ed3e0a0$var$load("lkwGP"),
    $90415cbe0ed3e0a0$var$load("fGPXi"),
    $90415cbe0ed3e0a0$var$load("2vAWg"),
    $90415cbe0ed3e0a0$var$load("7cABH"),
    $90415cbe0ed3e0a0$var$load("31vk5"),
    $90415cbe0ed3e0a0$var$load("dkgtP"),
    $90415cbe0ed3e0a0$var$load("g43Ev"),
    $90415cbe0ed3e0a0$var$load("2uVTT"),
    $90415cbe0ed3e0a0$var$load("hhss7"),
    $90415cbe0ed3e0a0$var$load("Wowvf"),
    $90415cbe0ed3e0a0$var$load("5RR9C"),
    $90415cbe0ed3e0a0$var$load("2PePB"),
    $90415cbe0ed3e0a0$var$load("bIPPg"),
    $90415cbe0ed3e0a0$var$load("lnKog"),
    $90415cbe0ed3e0a0$var$load("h3ABO"),
    $90415cbe0ed3e0a0$var$load("kC80R"),
    $90415cbe0ed3e0a0$var$load("7EorR"),
    $90415cbe0ed3e0a0$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lYk0G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lYk0G", function(module, exports) {

let $ffeeb920d352edae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffeeb920d352edae$var$load("2PePB"),
    $ffeeb920d352edae$var$load("bIPPg"),
    $ffeeb920d352edae$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $aXWIB = parcelRequire("aXWIB");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $aXWIB.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $aXWIB.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.641c47fe.js.map
